const LOGO_URL = 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/6f22b850c0f5b355d7e8e026585a5014.png';
const PHONE = '[PHONE NUMBER]';
const EMAIL = '[EMAIL ADDRESS]';

const navLinks = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why Choose Us', href: '#why' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  const year = new Date().getFullYear();

  return (
    <footer className="bg-navy-dark text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-md">
                <img
                  src={LOGO_URL}
                  alt="Precision North Home Inspections"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <p className="font-heading font-bold text-white leading-tight">Precision North</p>
                <p className="text-accent-light text-xs font-semibold tracking-widest uppercase">Home Inspections</p>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed mb-5">
              Thorough, reliable home inspections serving buyers, sellers, and homeowners throughout Northern Michigan and Up North communities.
            </p>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-fill text-accent-light text-sm"></i>
              </div>
              <span className="text-white/55 text-sm">Gaylord, Michigan</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 id="footer-links" className="font-heading font-bold text-white text-base mb-5">
              <a href="#hero">Quick Links</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-white/55 text-sm hover:text-accent-light transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-accent/60"></i>
                    </div>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact" className="font-heading font-bold text-white text-base mb-5">
              <a href="#contact">Contact Us</a>
            </h4>
            <div className="flex flex-col gap-3 mb-6">
              <a
                href={`tel:${PHONE}`}
                className="flex items-center gap-3 text-white/55 text-sm hover:text-accent-light transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent-light text-xs"></i>
                </div>
                {PHONE}
              </a>
              <a
                href={`mailto:${EMAIL}`}
                className="flex items-center gap-3 text-white/55 text-sm hover:text-accent-light transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-fill text-accent-light text-xs"></i>
                </div>
                {EMAIL}
              </a>
            </div>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent hover:bg-accent-light text-white text-sm font-semibold rounded-md cursor-pointer transition-colors whitespace-nowrap"
            >
              Schedule an Inspection
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/35 text-xs">
            &copy; {year} Precision North Home Inspections. All rights reserved.
          </p>
          <p className="text-white/35 text-xs">
            Serving Gaylord, MI &amp; Northern Michigan
          </p>
        </div>
      </div>
    </footer>
  );
}
